(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["travel-store"] && !Shopify.designMode) return;
  try {
    
(() => {
  const configElement=document.getElementById('travel-config');
  if(!configElement||configElement.dataset.initialized)return;
  configElement.dataset.initialized='true';
  const config=JSON.parse(configElement.textContent),s=config.strings;
  const $=sel=>document.querySelector(sel),dialog=$('#cart-dialog');
  const kitNames={solo:s.solo,duo:s.duo};
  const money=value=>new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:config.currency}).format(value/100);
  let selectedKit='solo',selectedColor='black',busy=false,cart=null;
  const variantFor=(kit=selectedKit,color=selectedColor)=>config.variants[color+'|'+kit]||null;
  const readCart=async()=>{const response=await fetch(config.root+'cart.js',{headers:{Accept:'application/json'},cache:'no-store'});if(!response.ok)throw new Error(s.network);return response.json()};
  const create=(tag,text,cls)=>{const node=document.createElement(tag);if(text!==undefined)node.textContent=text;if(cls)node.className=cls;return node};
  function updateSelection(){
    const variant=variantFor();
    document.querySelectorAll('input[name="kit"]').forEach(input=>{input.checked=input.value===selectedKit;input.closest('.offer').classList.toggle('selected',input.checked)});
    document.querySelectorAll('input[name="color"]').forEach(input=>{input.checked=input.value===selectedColor;input.closest('.color-option').classList.toggle('selected',input.checked)});
    document.querySelectorAll('.offer input[name="kit"]').forEach(input=>{
      const candidate=variantFor(input.value,selectedColor),price=input.closest('.offer').querySelector('.offer-price');
      price.textContent=candidate?.id?money(candidate.price):'—';
    });
    $('#offer-explainer').textContent=s[selectedKit+'_contents'];
    $('#sticky-kit-name').textContent=kitNames[selectedKit];$('#sticky-kit-description').textContent=s[selectedKit+'_contents'];
    $('#sticky-price').textContent=variant?.id?money(variant.price):'—';
    $('#included-bags strong').textContent='× '+(selectedKit==='duo'?2:1);
    $('#included-bags span').textContent='17L '+(selectedColor==='silver'?s.silver.toLowerCase():s.black.toLowerCase())+' compression bag';
    $('#visual-bag-count').textContent=s[selectedKit+'_bags'];$('.kit-composition strong:last-child').textContent=s.pump_count;
    $('.shop-product').dataset.bundle=selectedKit;$('.shop-product').dataset.color=selectedColor;
    for(const button of [$('#add-to-cart'),$('#sticky-add')]){
      button.disabled=busy||!variant?.available||!variant?.id;
      button.textContent=busy?s.adding:variant?.available?s.add+' · '+money(variant.price):s.unavailable;
    }
  }
  function lock(value){busy=value;updateSelection();dialog.querySelectorAll('button[data-key]').forEach(button=>button.disabled=value);$('#checkout').setAttribute('aria-disabled',String(value||!cart?.item_count));}
  function render(next){
    cart=next;config.currency=next.currency;
    $('#cart-count').textContent=next.item_count;$('#drawer-count').textContent=next.item_count;
    $('#cart-subtotal').textContent=money(next.total_price);$('#cart-summary').hidden=!next.item_count;
    const lines=$('#cart-lines');lines.replaceChildren();
    if(!next.item_count)lines.append(create('p',s.empty,'empty-cart'));
    next.items.forEach(item=>{
      const row=create('article',undefined,'cart-line');
      if(item.image){const img=create('img');img.src=item.image;img.width=88;img.height=88;img.alt=item.product_title;row.append(img)}
      const content=create('div'),title=create('div',undefined,'line-title');title.append(create('span',item.product_title),create('span',money(item.final_line_price)));content.append(title);
      if(item.variant_title)content.append(create('p',item.variant_title));
      const quantity=create('div',undefined,'quantity-row'),stepper=create('div',undefined,'quantity');
      for(const [action,label,amount] of [['decrease','−',item.quantity-1],['increase','+',item.quantity+1]]){
        const button=create('button',label);button.type='button';button.dataset.key=item.key;button.dataset.quantity=String(amount);button.dataset.action=action;button.setAttribute('aria-label',s[action]+' '+item.product_title);stepper.append(button);
        if(action==='decrease')stepper.append(create('span',String(item.quantity)));
      }
      const remove=create('button',s.remove,'remove');remove.dataset.key=item.key;remove.dataset.quantity='0';remove.type='button';remove.dataset.action='remove';quantity.append(stepper,remove);content.append(quantity);row.append(content);lines.append(row);
    });
    lock(busy);
  }
  async function mutate(path,payload){
    if(busy)return;
    lock(true);$('#cart-error').textContent='';
    let success=false;
    try{
      const response=await fetch(config.root+path,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(payload)});
      const result=await response.json();
      if(!response.ok)throw new Error(typeof result.description==='string'?result.description:s.network);
      render(await readCart());success=true;
    }catch(error){
      $('#cart-error').textContent=error.message||s.network;
      try{render(await readCart())}catch{ $('#cart-error').textContent=s.network; }
    }finally{lock(false)}
    return success;
  }
  async function addSelected(){
    const variant=variantFor();if(busy||!variant?.id||!variant?.available)return;
    if(!dialog.open)dialog.showModal();
    if(await mutate('cart/add.js',{items:[{id:variant.id,quantity:1}]}))$('#cart-feedback').textContent=s.added;
  }
  document.querySelectorAll('input[name="kit"]').forEach(input=>input.addEventListener('change',()=>{selectedKit=input.value;updateSelection()}));
  document.querySelectorAll('input[name="color"]').forEach(input=>input.addEventListener('change',()=>{selectedColor=input.value;updateSelection()}));
  $('#add-to-cart').addEventListener('click',addSelected);$('#sticky-add').addEventListener('click',addSelected);
  $('#open-cart').addEventListener('click',async()=>{if(!dialog.open)dialog.showModal();if(busy)return;lock(true);try{render(await readCart());$('#cart-error').textContent=''}catch{$('#cart-error').textContent=s.network}finally{lock(false)}});
  $('#close-cart').addEventListener('click',()=>dialog.close());
  $('#cart-lines').addEventListener('click',async event=>{const button=event.target.closest('button[data-key]');if(!button||busy)return;const key=button.dataset.key,action=button.dataset.action;await mutate('cart/change.js',{id:key,quantity:Number(button.dataset.quantity)});const replacement=[...dialog.querySelectorAll('button[data-key]')].find(el=>el.dataset.key===key&&el.dataset.action===action);(replacement||$('#close-cart')).focus()});
  $('#checkout').addEventListener('click',event=>{if(busy||!cart?.item_count)event.preventDefault()});
  dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close()}});
  window.ROOMFORM={compression:{frames:config.frames,labels:['Full','Compressing','Compressed']}};
  updateSelection();readCart().then(data=>{if(!cart&&!busy)render(data)}).catch(()=>{if(!cart&&!busy)$('#cart-error').textContent=s.network});
  const motion=matchMedia('(prefers-reduced-motion: reduce)');
  function videos(){document.querySelectorAll('.hero-visual video').forEach(video=>{video.autoplay=!motion.matches;if(motion.matches)video.pause()})}
  motion.addEventListener('change',videos);videos();
})();

'use strict';
(() => {
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  const bar = document.querySelector('#purchase-bar');
  const hero = document.querySelector('.hero');
  const parallax = matchMedia('(min-width: 761px) and (hover: hover) and (pointer: fine)');
  const heroImage = hero.querySelector('.hero-visual > img');
  const engine = document.querySelector('#compression');
  const image = document.querySelector('#compression-image');
  const controls = [...document.querySelectorAll('[data-stage]')];
  const settings = window.ROOMFORM.compression;
  let manual = false, raf = 0, lastStage = -1;
  const clamp = n => Math.min(1,Math.max(0,n));
  function paint(progress) {
    const stage = progress < .25 ? 0 : progress < .75 ? 1 : 2;
    engine.style.setProperty('--compression-progress',progress);
    engine.style.setProperty('--compression-scale',1-progress*.38);
    if(stage!==lastStage){
      document.querySelector('#compression-state').textContent=settings.labels[stage];
      controls.forEach((b,i)=>b.setAttribute('aria-pressed',String(i===stage)));
      if(settings.frames.length===3){image.src=settings.frames[stage];image.parentElement.classList.add('has-real-frames')}
      lastStage=stage;
    }
  }
  function update(){
    raf=0;
    const heroRect=hero.getBoundingClientRect();
    const visible=heroRect.bottom<=0;
    if(heroImage){
      const drift=!reduce.matches&&parallax.matches?clamp(-heroRect.top/Math.max(heroRect.height,1))*22:0;
      heroImage.style.setProperty('--hero-drift',drift.toFixed(2)+'px');
    }
    bar.classList.toggle('is-visible',visible);bar.inert=!visible;
    if(!engine.hidden&&!manual&&!reduce.matches){
      const rect=engine.getBoundingClientRect();
      const pin=engine.querySelector('.compression-pin');
      const distance=Math.max(rect.height-pin.offsetHeight,1);
      paint(clamp(-rect.top/distance));
    }
  }
  const requestUpdate=()=>{if(!raf)raf=requestAnimationFrame(update)};
  parallax.addEventListener('change',requestUpdate);
  addEventListener('scroll',requestUpdate,{passive:true});addEventListener('resize',requestUpdate,{passive:true});
  new ResizeObserver(entries=>{const height=Math.ceil(entries[0].target.getBoundingClientRect().height);document.documentElement.style.setProperty('--purchase-height',height+'px')}).observe(bar);
  controls.forEach((button,index)=>button.addEventListener('click',()=>{manual=true;paint(index/2);document.querySelector('#resume-scroll').hidden=reduce.matches}));
  document.querySelector('#resume-scroll').addEventListener('click',()=>{manual=false;document.querySelector('#resume-scroll').hidden=true;requestUpdate()});
  function motionPreference(){manual=false;document.querySelector('#resume-scroll').hidden=true;document.querySelector('#motion-mode').textContent=reduce.matches?'Reduced motion · Select a stage to explore':'Scroll to explore · Or select a stage';if(reduce.matches)paint(0);requestUpdate()}
  reduce.addEventListener('change',motionPreference);motionPreference();
  const candidates=[...document.querySelectorAll('.manifesto>div,.process article,.pump-copy,.pump-visual,.detail-visual,.detail-copy,.about-teaser>div,.proof-heading,.proof-slots article,.shop-heading,.shop-panel,.faq>div,.closing')];
  const observer='IntersectionObserver' in window?new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-revealed');observer.unobserve(entry.target)}}),{threshold:0,rootMargin:'0px 0px -24px 0px'}):null;
  if(observer&&!reduce.matches)candidates.forEach(el=>{
    if(!el.closest('[hidden]')&&el.getBoundingClientRect().top>innerHeight){
      const siblings=[...el.parentElement.children].filter(sibling=>candidates.includes(sibling));
      const delay=innerWidth>760?Math.min(siblings.indexOf(el)*50,100):0;
      el.style.setProperty('--reveal-delay',delay+'ms');
      observer.observe(el);el.classList.add('reveal-pending','reveal-ready');
    }
  });
  reduce.addEventListener('change',()=>{if(reduce.matches){candidates.forEach(el=>el.classList.add('is-revealed'));observer?.disconnect()}});
  document.addEventListener('focusin',event=>{const el=event.target;if(!(el instanceof HTMLElement)||bar.contains(el)||el.closest('dialog'))return;const rect=el.getBoundingClientRect();if(bar.classList.contains('is-visible')&&rect.bottom>innerHeight-bar.offsetHeight-12)el.scrollIntoView({block:'center',behavior:'instant'});el.closest('.reveal-pending')?.classList.add('is-revealed')});
  document.querySelectorAll('.faq-items details').forEach(details=>{
    const summary=details.querySelector('summary');let animation=null,desired=details.open;
    summary.addEventListener('click',event=>{
      if(reduce.matches)return;
      event.preventDefault();desired=!desired;
      const from=details.getBoundingClientRect().height;animation?.cancel();
      details.style.height='';details.open=true;
      const to=desired?details.getBoundingClientRect().height:summary.getBoundingClientRect().height;
      animation=details.animate({height:[from+'px',to+'px']},{duration:280,easing:'cubic-bezier(.2,.65,.3,1)'});
      animation.onfinish=()=>{details.open=desired;details.style.height='';animation=null};
    });
    reduce.addEventListener('change',()=>{animation?.cancel();animation=null;details.style.height='';desired=details.open});
  });
})();

  } catch(e) { console.error(e); }
})();
})();
